import React, { useRef } from 'react'

import Card from './AppointmentCardStyles'
import Modal from '../../containers/common/Modal'


const PayModal = ({
    onClose = () => { },
    onSubmit,
    pendingCopay,
    description = 'Doctors fees has been updated. Please pay the outstanding amount to confirm your appointment.'
}) => {

    const divRef = useRef(null)

    const handleClick = (e) => {
        const target = e.target
        if (divRef.current && divRef.current.contains(target)) {
            return;
        }

        setTimeout(onClose, 200);
    }
    return <Modal>
        <div className="modalContainer" onClick={handleClick}>
            <div ref={divRef} className="bg-textbox flex flex-col items-center rounded-12 mx-12px">
                <div className="p-24px mb-16px flex flex-col items-center justify-center">
                    <Card.DoctorName>{description}</Card.DoctorName>
                    <div
                        style={{
                            fontSize: '24px',
                            fontWeight: '600',
                            marginTop: '30px',
                        }}
                    >
                        ₹ {pendingCopay}
                    </div>
                    <Card.PayButton onClick={onSubmit}>
                        Pay & Confirm
                    </Card.PayButton>
                </div>
            </div>
        </div>
    </Modal>
}

export default PayModal